export default function BlobBackground() {
  return (
    <>
      {/* Radial gradient overlay */}
      <div
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 20%, rgba(198,80,60,0.12) 0%, rgba(251,250,247,0) 70%)',
        }}
      />

      {/* Blob 1 — top-left */}
      <div
        className="absolute z-0 pointer-events-none animate-blob-float-slow"
        style={{
          top: '8%',
          left: '-8%',
          width: '220px',
          height: '220px',
          borderRadius: '63% 37% 54% 46% / 55% 48% 52% 45%',
          background: 'rgba(198,80,60,0.09)',
        }}
      />

      {/* Blob 2 — bottom-right */}
      <div
        className="absolute z-0 pointer-events-none animate-blob-float-slower"
        style={{
          bottom: '14%',
          right: '-6%',
          width: '180px',
          height: '180px',
          borderRadius: '41% 59% 62% 38% / 48% 54% 46% 52%',
          background: 'rgba(198,80,60,0.07)',
        }}
      />
    </>
  );
}